const loadJuicer = () => {
  const feed = document.getElementById('juicer-feed')

  const params = `?per=${feed.dataset.rows}&pages=${feed.dataset.pages}`
  const scriptURL = `https://www.juicer.io/embed/${feed.dataset.name}/embed-code.js${params}`

  let juicerLoaded = false

  /* Use IntersectionObserver to fire once when the feed enters the viewport.
     rootMargin of 200px triggers slightly before the element is visible,
     giving the script time to load before the user reaches it. */
  const observer = new IntersectionObserver(
    (entries, obs) => {
      if (entries[0].isIntersecting && !juicerLoaded) {
        loadJuicerScript()
        obs.disconnect()
      }
    },
    { rootMargin: '200px' },
  )

  observer.observe(feed)

  /* Dynamically inject the Juicer embed script */
  function loadJuicerScript() {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = scriptURL

    script.onload = function () {
      juicerLoaded = true
    }

    feed.appendChild(script)
  }
}

export default loadJuicer
